import { Event } from '../Event'
import { Identity } from '../../constants'

export interface ClientSessionResetEventProperties {
  previous_id?: string
  current_id: string
}

export class ClientSessionResetEvent extends Event<ClientSessionResetEventProperties> {
  static displayName = 'Client Session Reset'

  static allowedIdentities = [Identity.Guest, Identity.Consumer]
}
